module.exports = __webpack_public_path__ + "img/arrow-outlined-black.2ddb75bd.svg";